<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>视光配镜</el-breadcrumb-item>
      <el-breadcrumb-item>订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clicksearch" placeholder="请输入订单号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.orderstatus" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择订单状态" value="-1"></el-option>
              <el-option label="待支付" value="0"></el-option>
              <el-option label="待发货" value="1"></el-option>
              <el-option label="待收货" value="2"></el-option>
              <el-option label="已完成" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.shipmenttime" @keyup.enter.native="clicksearch" placeholder="请输入出货时间" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column type="expand" min-width="1%">
            <template slot-scope="props">
              <el-table :data="props.row.ListSub" height="200" class="tableInner" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
                <el-table-column prop="Producttype" label="产品类型"></el-table-column>
                <el-table-column prop="Suppliers" label="供应商"></el-table-column>
                <el-table-column prop="Productname" label="商品名称"></el-table-column>
                <el-table-column prop="Specifications" label="规格型号"></el-table-column>
                <el-table-column prop="Units" label="计量单位"></el-table-column>
                <el-table-column prop="Shipmentnum" label="出货数量"></el-table-column>
                <el-table-column prop="Salesamount" label="销售金额"></el-table-column>
                <el-table-column prop="Note" label="备注"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="Orderid" label="订单号" min-width="6%"></el-table-column>
          <el-table-column prop="Shipmenttime" label="出货时间" min-width="6%"></el-table-column>
          <el-table-column prop="Customername" label="收货人" min-width="6%"></el-table-column>
          <el-table-column prop="Phone" label="手机号码" min-width="6%"></el-table-column>
          <el-table-column prop="Consigneeaddress" label="收件地址" min-width="6%"></el-table-column>
          <el-table-column prop="Ordertime" label="下单时间" min-width="6%"></el-table-column>
          <el-table-column prop="Reduceamount" label="已优惠金额" min-width="6%"></el-table-column>
          <el-table-column prop="Endamount" label="最终金额" min-width="6%"></el-table-column>
          <el-table-column prop="Deliverytype" label="发货形式" min-width="6%"></el-table-column>
          <el-table-column prop="Trackingnumber" label="物流单号" min-width="6%"></el-table-column>
          <el-table-column prop="OrderstatusName" label="订单状态" min-width="6%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="8%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Orderstatus == 1 || scope.row.Orderstatus == 2" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickmodify(scope.row)">填写发货信息</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 更新 start -->
    <el-tab-pane label="更新" name="three" disabled="disabled">
      <el-form :model="editForm" ref="editFormRef" label-width="170px">
        <el-form-item label="发货形式" class="addAdminForm">
          <el-input v-model="editForm.deliverytype"></el-input>
        </el-form-item>
        <el-form-item label="物流单号" class="addAdminForm">
          <el-input v-model="editForm.trackingnumber"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 更新 end -->

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyOptometristOrder',
  data () {
    return {
      activeName: 'first',
      ProductNameOptions: [],
      SpecificationsOptions: [],
      editForm: {
        orderid: '',
        deliverytype: '',
        trackingnumber: ''
      },
      // 查询
      keywords: {
        orderid: '',
        orderstatus: '-1',
        shipmenttime: '',
        suppliers: '',
        productname: '',
        specifications: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apiGetOptometristOrderNum()
    this.apiGetOptometristOrderList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    selectchange(ptype){
    },
    clickmodify (row) {
      this.activeName = 'three'

      this.editForm.orderid = row.Orderid
      this.editForm.deliverytype = row.Deliverytype
      this.editForm.trackingnumber = row.Trackingnumber
   },
    clicksave () {
      this.apiEditOptometristOrder()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetOptometristOrderNum()
      this.apiGetOptometristOrderList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetOptometristOrderList()
    },
    apiGetOptometristOrderNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        shipmenttime: that.keywords.shipmenttime,
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristOrderNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetOptometristOrderList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        shipmenttime: that.keywords.shipmenttime,
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristOrderList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditOptometristOrder: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditOptometristOrder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristOrderNum()
            that.apiGetOptometristOrderList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
